import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Button from '/component/base/Button';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {Popup} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './ExitPopup.style';

interface ExitPopupProps {
  description: string;
  title: string;
  handleDiscardButton: () => void;
  handleCancelButton: () => void;
  discardButtonStyle: object;
}

const ExitPopup: React.FC<ExitPopupProps> = ({
  description = '',
  title = '',
  handleDiscardButton = noop,
  handleCancelButton = noop,
  discardButtonStyle = null,
}) => {
  const {ts} = useTranslation('exitPopup');
  return (
    <View
      style={styles.container}
      {...testProperties(Popup.popupRoot, true)}
      accessible={false}>
      <View style={styles.headerContainer}>
        <View
          style={styles.popupText}
          accessible={true}
          testID={Popup.popupHeader}>
          <Text
            testID={Popup.popupHeader}
            accessible={true}
            variant="heading"
            style={styles.title}
            allowFontScaling
            maxFontSizeMultiplier={2}
            {...testProperties(Popup.popupHeader)}>
            {title}
          </Text>
        </View>
        <TouchableOpacity
          accessibilityLabel={ts('close', 'close')}
          onPress={handleCancelButton}
          {...testProperties(null, true)}>
          <Icon style={styles.actionIcon} name={'close'} />
        </TouchableOpacity>
      </View>
      <Text
        testID={Popup.popupDescription}
        accessible={true}
        variant="body"
        style={styles.description}
        allowFontScaling
        maxFontSizeMultiplier={2}
        {...testProperties(Popup.popupDescription)}>
        {description}
      </Text>
      <View style={styles.buttonsContainer}>
        <Button
          allowFontScaling
          maxFontSizeMultiplier={2}
          type="primary"
          onPress={handleDiscardButton}
          style={{base: [styles.discardButton, discardButtonStyle]}}
          testID={Popup.popupDiscard}>
          Discard changes
        </Button>
        <>
          <View style={styles.split} />
          <Button
            allowFontScaling
            maxFontSizeMultiplier={2}
            type="secondary"
            style={{base: styles.cancelButton}}
            onPress={handleCancelButton}
            testID={Popup.popupCancel}>
            Cancel
          </Button>
        </>
      </View>
    </View>
  );
};

export default ExitPopup;
